import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Http from "../../../../Common/Http";
import IsLogin from "../../../../Common/IsLogin";
import useRequiredFields from "../../../../../hooks/useRequiredFields";
import Select from "react-select";
const Create = () => {
  const navigate = useNavigate();
  const { checkRequiredFields } = useRequiredFields();
  const { id } = useParams();
  const [list, setList] = useState([]);
  const [data, setData] = useState([]);
  const [dataDeepCopy, setDataDeepCopy] = useState([]);
  const [inputs, setInputs] = useState({
    entry_date: new Date().toISOString().split("T")[0],
  });
  const [product, setProduct] = useState({});
  const [error, setError] = useState({});
  const [role, setRole] = useState("");
  const [receiveData, setReceiveData] = useState([]);
  const [receipeNotFound, setReceipeNotFound] = useState("Receipe Not Found");
  const [receipe, setRecipe] = useState([]);
  const [receipeForSet, setReceipeForSet] = useState([]);
  const [totalRMQuantitiesForSet, setTotalRMQuantitiesForSet] = useState({});
  const [DeparmenType, setDeparmenType] = useState(null);
  const [production, setProduction] = useState(0);
  const [totalProductionAndTotalTransfer, setTotalProductionAndTotalTransfer] =
    useState();
  const [totalRMQuantities, setTotalRMQuantities] = useState({});
  const [groupSetData, setGroupSetData] = useState();
  const [count, setCount] = useState();
  const [sets, setSets] = useState();
  const [productionQty, setProductionQty] = useState(0);
  const [recipeRowsByItem, setRecipeRowsByItem] = useState({});
  const [recipeOptions, setRecipeOptions] = useState([]);
  const [recipeErrorMessages, setRecipeErrorMessages] = useState({});

  const fetchData = async () => {
    try {
      const resRole = await Http.get("/staff-type-check");
      setRole(resRole.data);

      const resRequisition = await Http.get("/requisition-art/" + id);
      const items = resRequisition.data.items;

      const res4 = await Http.get(
        "/last-code-increment-by-one/companies/code/COM",
      );
      setInputs((values) => ({ ...values, code: res4.data }));

      const groupedArray = [];
      const noSetIdItems = [];

      items.forEach((item) => {
        if (item.set_id != null) {
          // Check if group for this set_id already exists
          const existingGroup = groupedArray.find(
            (group) => group.set_id === item.set_id,
          );

          // Ensure item has inner_qty = 0
          const itemWithInnerQty = {
            ...item,
            inner_qty: 0
          };

          if (existingGroup) {
            existingGroup.items.push(itemWithInnerQty);
          } else {
            groupedArray.push({
              set_id: item.set_id,
              required_qty_export: item.qty_export || "",
              required_qty_a_class: item.qty_a_class || "",
              required_qty_b_class: item.qty_b_class || "",
              required_qty_c_class: item.qty_c_class || "",
              required_master_qty: item.master_qty || "",
              total_inner_qty: item.sets.total_inner_qty || "",
              total_master_qty: item.sets.total_master_qty || "",
              total_delivery_inner_qty:
                item.sets.total_delivery_inner_qty || "",
              total_delivery_master_qty:
                item.sets.total_delivery_master_qty || "",
              set_name: item.sets.name || "",
              items: [itemWithInnerQty],
            });
            // console.log(groupedArray);
          }
        } else {
          item.qty_export = "";
          item.qty_a_class = "";
          item.qty_b_class = "";
          item.qty_c_class = "";
          item.master_qty = "";
          item.inner_qty = 0; // Set inner_qty to 0 for items without set_id
          noSetIdItems.push(item);
        }
      });

      // items without set_id

      setGroupSetData(groupedArray);
      setReceiveData(resRequisition.data);
      setList(noSetIdItems);
      setCount(noSetIdItems.length);

      // Filter total production and transfer data based on planning_item_ids from requisition
      const planningItemIds = resRequisition.data.items.map(
        (item) => item?.planning_item_id,
      );
      const resTotalProduction = await Http.get(
        "/total-transfer-and-total-production/" + id,
      );

      // Filter the response to only include relevant planning_item_ids
      const filteredTotalProduction = resTotalProduction.data.filter((item) =>
        planningItemIds.includes(item?.planning_item_id),
      );

      // Create a mapping for easy access
      const totalProductionMap = {};
      filteredTotalProduction.forEach((item) => {
        totalProductionMap[item?.planning_item_id] = {
          total_production_qty: item.total_production_qty,
          total_transfer_qty: item.total_delivery_qty, // Assuming this is the total transfer
          opening_balance:
            Number(item.total_production_qty) - Number(item.total_delivery_qty), // Assuming this is the total transfer
          total_production_qty_export: item.total_production_qty_export,
          total_delivery_export_qty: item.total_delivery_export_qty,
          // also a,b,c class
          total_production_qty_a: item.total_production_qty_a,
          total_delivery_a_class: item.total_delivery_a_class,
          total_production_qty_b: item.total_production_qty_b,
          total_delivery_b_class: item.total_delivery_b_class,
          total_production_qty_c: item.total_production_qty_c,
          total_delivery_c_class: item.total_delivery_c_class,
          total_production_inner_qty: item?.total_inner_qty,
          total_production_master_qty: item?.total_master_qty,
          total_delivery_inner_qty: item?.total_delivery_inner_qty,
          total_delivery_master_qty: item?.total_delivery_master_qty,
        };
      });

      setTotalProductionAndTotalTransfer(totalProductionMap);

      const resBatchNo = await Http.get(
        "/last-code-increment-by-one/requisition_arts/receipt_no/RD",
      );
      setInputs((values) => ({ ...values, ["receipt_no"]: resBatchNo.data }));

      if (
        resRequisition.data.to_department_art_id === 16 ||
        resRequisition.data.to_department_art_id === 19
      ) {
        setDeparmenType(resRequisition.data.to_department.user_type);
      } else {
        setDeparmenType(resRequisition.data.from_department.user_type);
      }
      if (resRequisition.data.to_department_art_id == 14) {
        setDeparmenType(resRequisition.data.department.user_type);
      }
    } catch (e) {
      console.error("Error fetching data:", e);
    }
  };

  // console.log(groupSetData, "groupSetData");
  // useEffect(() => {
  //   $("body").addClass("collapse-menu");
  //   fetchData();
  // }, []);
  // Handle Change for Inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const fetchReceipeData = async (productId) => {
    try {
      const updatedInputs = {
        receipt_no: inputs.receipt_no,
        product_id: productId,
      };
    } catch (error) {
      console.error("Error loading receipe data:", error);
    }
  };

  const fetchRecipeOptions = async () => {
    try {
      const resRmpm = await Http.get("/product-list/raw_materials");
      const rmpmOptions = resRmpm.data.filter(
        (item) => item.department_finished_good === null,
      );
      const options = rmpmOptions.map((item) => ({
        value: item.id,
        label: `${item.code} - ${item.name} - ${item?.unit?.name}`,
        unitName: item?.unit?.name,
      }));
      setRecipeOptions(options);
    } catch (error) {
      console.error("Error loading raw materials:", error);
    }
  };

  const getInitialRecipeRows = () => [{ rmpm_id: "", qty: "", desc: "" }];

  const addMoreRecipeRow = (itemKey) => {
    setRecipeRowsByItem((prev) => {
      const existingRows = prev[itemKey] || getInitialRecipeRows();
      return {
        ...prev,
        [itemKey]: [...existingRows, { rmpm_id: "", qty: "", desc: "" }],
      };
    });
  };

  const removeRecipeRow = (itemKey, index) => {
    setRecipeRowsByItem((prev) => {
      const existingRows = prev[itemKey] || getInitialRecipeRows();
      const rows = [...existingRows];
      rows.splice(index, 1);
      return {
        ...prev,
        [itemKey]: rows.length > 0 ? rows : getInitialRecipeRows(),
      };
    });
  };

  const handleRecipeRowChange = (e, itemKey, index) => {
    const { name, value } = e.target;
    setRecipeRowsByItem((prev) => {
      const existingRows = prev[itemKey] || getInitialRecipeRows();
      const rows = [...existingRows];
      rows[index] = { ...rows[index], [name]: value };
      return {
        ...prev,
        [itemKey]: rows,
      };
    });
  };

  const handleRecipeNumberInputChange = (e, itemKey, index) => {
    const { name, value } = e.target;
    if (/^\d*$/.test(value)) {
      setRecipeRowsByItem((prev) => {
        const existingRows = prev[itemKey] || getInitialRecipeRows();
        const rows = [...existingRows];
        rows[index] = { ...rows[index], [name]: value };
        return {
          ...prev,
          [itemKey]: rows,
        };
      });
      setRecipeErrorMessages((prev) => ({
        ...prev,
        [itemKey]: "",
      }));
    } else {
      setRecipeErrorMessages((prev) => ({
        ...prev,
        [itemKey]: "Only numbers are allowed!",
      }));
    }
  };

  const handleRecipeSelectChange = (
    selectedOption,
    actionMeta,
    itemKey,
    index,
  ) => {
    setRecipeRowsByItem((prev) => {
      const existingRows = prev[itemKey] || getInitialRecipeRows();
      const rows = [...existingRows];
      rows[index] = {
        ...rows[index],
        rmpm_id: selectedOption.value,
      };
      return {
        ...prev,
        [itemKey]: rows,
      };
    });
  };

  useEffect(() => {
    document.body.classList.add("collapse-menu");
    const initializeData = async () => {
      await fetchData();
      await fetchInitialData();
      await fetchRecipeOptions();
    };
    initializeData();
  }, []);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setInputs((values) => ({ ...values, [name]: value }));
  // };

  const handleInputChange = (
    e,
    index,
    totalProduction = 0,
    totalTransfer = 0,
  ) => {
    let { name, value } = e.target;
    let input = Number(value);

    let adjustedProduction = Number(totalProduction);

    // If field is production_qty, we want to add input value to totalProduction
    if (
      name === "production_qty" ||
      name === "qty_export" ||
      name === "qty_a_class" ||
      name === "qty_b_class" ||
      (name === "qty_c_class" && input > 0)
    ) {
      setProduction(input);
    }
    let errorFound = false;
    // console.log(input, "input");

    // If field is production_qty, we want to add input value to totalProduction
    const availableQty =
      adjustedProduction + production - Number(totalTransfer);

    if (
      name === "delivery_qty_a_class" ||
      name === "delivery_qty_b_class" ||
      name === "delivery_qty_c_class" ||
      name === "delivery_qty_export"
    ) {
      if (input > production + adjustedProduction) {
        Swal.fire({
          icon: "error",
          title: "Invalid Transfer",
          text: "Transfer can't be more than " + availableQty,
          confirmButtonText: "OK",
        });
        value = 0;
      }
    }

    const updatedList = [...list];
    let inputValue = value;

    // if (name === "transfer_qty") {
    //   const totalProductionQty = updatedList[index].total_production_qty || 0;
    //   const productionQty = parseFloat(updatedList[index].production_qty) || 0;
    //   const totalTransferQty = updatedList[index].total_transfer_qty || 0;

    //   const maxTransferQty =
    //     totalProductionQty + productionQty - totalTransferQty;

    //   // if (inputValue > maxTransferQty) {
    //   //   Swal.fire({
    //   //     icon: "error",
    //   //     title: "Validation Error",
    //   //     text: `Transfer quantity cannot exceed ${maxTransferQty}.`,
    //   //   });
    //   //   inputValue = maxTransferQty; // Reset to the maximum allowed value
    //   // }
    // }

    updatedList[index][name] = inputValue;
    setList(updatedList);
  };

  const fetchInitialData = async () => {
    try {
      const resRole = await Http.get("/staff-type-check");
      setRole(resRole.data);
      const resProduct = await Http.get("/receipe-finished-good");
      const latestProduct = resProduct.data[resProduct.data.length - 1];
      const productId = latestProduct.value;
      setProduct(latestProduct);
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  };
  const formSubmit = () => {
    if (checkRequiredFields() === true) {
      const concatReceipe = Object.entries(recipeRowsByItem || {}).flatMap(
        ([itemKey, rows]) => {
          // Find the correct productIndex for this itemKey
          const productIndex = list.findIndex(
            (item, idx) =>
              (item.id || item.planning_item_id || idx).toString() ===
              itemKey.toString(),
          );

          return rows
            .filter((row) => row.rmpm_id && row.qty)
            .map((row, itemIndex) => ({
              receipe_id: 0,
              receipe_product_id: row.rmpm_id,
              qty: Number(row.qty),
              desc: row.desc || "",
              itemIndex: itemIndex,
              uniqueKey: `${row.rmpm_id}_${productIndex}`,
              productIndex: productIndex,
            }));
        },
      );

      const finalConcatReceipe = [
        ...concatReceipe,
        ...receipe,
        ...receipeForSet,
      ];

      // Ensure all items in list have inner_qty = 0
      const updatedList = list.map(item => ({
        ...item,
        inner_qty: 0
      }));

      // Ensure all items in sets have inner_qty = 0
      const updatedSets = sets ? sets.map(set => ({
        ...set,
        items: set.items.map(item => ({
          ...item,
          inner_qty: 0
        }))
      })) : sets;

      const formData = {
        ...inputs,
        items: updatedList,
        sets: updatedSets,
        production_against_requisition_art_id: receiveData.id,
        
        production_against_requisition_issue_id: id,
        to_department_id: receiveData.from_department_art_id,
        planning_id:
          receiveData.from_department_art_id === 27
            ? 0
            : receiveData.planning_id,
        concatReceipe: finalConcatReceipe,
        entry_date: inputs.entry_date,
      };
      console.log(list);
      Http.post(`/production-transfer`, formData)
        .then((res) => {
          navigate("/department-requisition-jcg", {
            state: { message: res.data.message, type: "success" },
          });
        })
        .catch(function (e) {
          setError(e.response.data.errors);
        });
    }
  };

  const handleRecepieChange = async (
    e,
    stockQty,
    rmId,
    index,
    productIndex,
  ) => {
    const { value } = e.target;
    let numericValue = Number(value);

    // Create a unique key for each repetition using rmId and productIndex
    const uniqueKey = `${rmId}_${productIndex}`;

    // Calculate total quantity used for this RM across all repetitions
    const currentTotals = { ...totalRMQuantities };
    const existingTotal = Object.values(receipe)
      .filter((item) => item.receipe_product_id === rmId)
      .reduce((sum, item) => sum + (Number(item.qty) || 0), 0);

    // Subtract the previous value for this specific input if it exists
    const previousValue =
      receipe.find(
        (item) =>
          item.receipe_product_id === rmId && item.uniqueKey === uniqueKey,
      )?.qty || 0;

    const otherItemsTotal = existingTotal - previousValue;
    const newTotal = otherItemsTotal + numericValue;

    // Check if total quantity exceeds stock
    // if (newTotal > stockQty) {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Out of Stock",
    //     text: `Total quantity across all items (${newTotal}). Which exceeds stock quantity (${stockQty}).`,
    //     confirmButtonText: "OK",
    //   });

    //   e.target.value = previousValue || 0; // Reset to previous value instead of 0
    //   numericValue = previousValue || 0;
    // }

    // Update recipe state with the new value
    setRecipe((prevRecipe) => {
      const existingIndex = prevRecipe.findIndex(
        (item) =>
          item.receipe_product_id === rmId && item.uniqueKey === uniqueKey,
      );

      if (existingIndex !== -1) {
        return prevRecipe.map((item, idx) =>
          idx === existingIndex
            ? { ...item, receipe_id: rmId, qty: numericValue }
            : item,
        );
      } else {
        return [
          ...prevRecipe,
          {
            receipe_id: rmId,
            receipe_product_id: rmId,
            qty: numericValue,
            itemIndex: index,
            uniqueKey,
            productIndex,
          },
        ];
      }
    });

    // Update total quantities
    setTotalRMQuantities((prev) => ({
      ...prev,
      [rmId]: newTotal,
    }));
  };

  const handleRecepieChangeForSet = async (
    e,
    stockQty,
    rmId,
    index,
    productIndex,
  ) => {
    const { value } = e.target;
    let numericValue = Number(value);

    // Create a unique key for each repetition using rmId and productIndex
    const uniqueKey = `${rmId}_${productIndex}`;

    // Calculate total quantity used for this RM across all repetitions
    const currentTotals = { ...totalRMQuantities };
    const existingTotal = Object.values(receipeForSet)
      .filter((item) => item.receipe_product_id === rmId)
      .reduce((sum, item) => sum + (Number(item.qty) || 0), 0);

    // Subtract the previous value for this specific input if it exists
    const previousValue =
      receipeForSet.find(
        (item) =>
          item.receipe_product_id === rmId && item.uniqueKey === uniqueKey,
      )?.qty || 0;

    const otherItemsTotal = existingTotal - previousValue;
    const newTotal = otherItemsTotal + numericValue;

    // Check if total quantity exceeds stock
    // if (newTotal > stockQty) {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Out of Stock",
    //     text: `Total quantity across all items (${newTotal}). Which exceeds stock quantity (${stockQty}).`,
    //     confirmButtonText: "OK",
    //   });

    //   e.target.value = previousValue || 0; // Reset to previous value instead of 0
    //   numericValue = previousValue || 0;
    // }

    // Update recipe state with the new value
    setReceipeForSet((prevRecipe) => {
      const existingIndex = prevRecipe.findIndex(
        (item) =>
          item.receipe_product_id === rmId && item.uniqueKey === uniqueKey,
      );

      if (existingIndex !== -1) {
        return prevRecipe.map((item, idx) =>
          idx === existingIndex
            ? { ...item, receipe_id: rmId, qty: numericValue }
            : item,
        );
      } else {
        return [
          ...prevRecipe,
          {
            receipe_id: rmId,
            receipe_product_id: rmId,
            qty: numericValue,
            itemIndex: index,
            uniqueKey,
            productIndex,
          },
        ];
      }
    });

    // Update total quantities
    setTotalRMQuantitiesForSet((prev) => ({
      ...prev,
      [rmId]: newTotal,
    }));
  };

  // console.log("setTotalRMQuantities", totalRMQuantities);

  const [displayErrorMessage, setDisplayErrorMessage] = useState({
    qty_export: "",
    delivery_qty_export: "",
  });
  const [innerQty, setInnerQty] = useState(0);
  const [exportQty, setExportQty] = useState(0);
  const [aClassQty, setAClassQty] = useState(0);
  const [bClassQty, setBClassQty] = useState(0);
  const [cClassQty, setCClassQty] = useState(0);
  const [masterQty, setMasterQty] = useState(0);

  const handleNumberInputChange = (
    e,
    index,
    totalProduction = 0,
    totalTransfer = 0,
  ) => {
    let { name, value } = e.target;
    const inputValue = Number(value);
    console.log("AJAKJSKJS");

    let adjustedProduction = Number(totalProduction);

    // If field is production_qty, we want to add input value to totalProduction
    if (
      name === "production_qty" ||
      name === "qty_export" ||
      name === "qty_a_class" ||
      name === "qty_b_class" ||
      (name === "qty_c_class" && inputValue > 0)
    ) {
      setProduction(inputValue);
      setProductionQty(inputValue);
    }

    // if (name === "transfer_qty" && inputValue > productionQty) {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Validation Error",
    //     text: "Transfer quantity is greater than production quantity.",
    //     confirmButtonText: "OK",
    //   });
    //   e.target.value = 0; // Reset to the maximum allowed value
    // }

    if (name === "qty_export") {
      setExportQty(inputValue);
    }
    if (name === "qty_a_class") {
      setAClassQty(inputValue);
    }
    if (name === "qty_b_class") {
      setBClassQty(inputValue);
    }
    if (name === "qty_c_class") {
      setCClassQty(inputValue);
    }
    if (name === "master_qty") {
      setMasterQty(inputValue);
    }

    // if (name === "inner_transfer_qty") {
    //   if (inputValue > innerQty) {
    //     Swal.fire({
    //       icon: "error",
    //       title: "Validation Error",
    //       text: "Transfer quantity is greater than production quantity.",
    //       confirmButtonText: "OK",
    //     });
    //     e.target.value = 0;
    //   }
    // }
    // if (name === "master_transfer_qty") {
    //   if (inputValue > masterQty) {
    //     Swal.fire({
    //       icon: "error",
    //       title: "Validation Error",
    //       text: "Transfer quantity is greater than production quantity.",
    //       confirmButtonText: "OK",
    //     });
    //     e.target.value = 0;
    //   }
    // }

    const availableQty =
      adjustedProduction + production - Number(totalTransfer);

    if (totalProduction > 0 && totalTransfer > 0) {
      if (inputValue > availableQty) {
        Swal.fire({
          icon: "error",
          title: "Invalid Transfer",
          text: "Transfer can't be more than " + availableQty,
          confirmButtonText: "OK",
        });
        e.target.value = 0;
      }
    }
    if (/^\d*$/.test(value)) {
      const updatedList = [...list];

      if (name === "transfer_qty") {
        const totalProductionQty = updatedList[index].total_production_qty || 0;
        const productionQty =
          parseFloat(updatedList[index].production_qty) || 0;
        const totalTransferQty = updatedList[index].total_transfer_qty || 0;

        const maxTransferQty =
          totalProductionQty + productionQty - totalTransferQty;

        // if (inputValue > maxTransferQty) {
        //   Swal.fire({
        //     icon: "error",
        //     title: "Validation Error",
        //     text: `Transfer quantity cannot exceed ${maxTransferQty}.`,
        //   });
        //   inputValue = maxTransferQty; // Reset to the maximum allowed value
        // }

        setDisplayErrorMessage((prev) => ({ ...prev, [name]: "" })); // Clear error
      } else {
        setDisplayErrorMessage((prev) => ({ ...prev, [name]: "" })); // Clear error for numeric input
      }
      updatedList[index][name] = value;
      setList(updatedList);
    } else {
      setDisplayErrorMessage((prev) => ({
        ...prev,
        [name]: "Only numbers are allowed!",
      }));
    }
  };

  // console.log(list, "list");
  const handleNumberInputChangeForTransfer = (e, index) => {
    const { name, value } = e.target;
    const inputValue = Number(value);

    let updatedList = [...list];

    // Ensure only numeric input is accepted
    if (/^\d*$/.test(value)) {
      if (name === "master_qty" || 
        name === "qty_export" ||
        name === "qty_a_class" ||
        name === "qty_b_class" ||
        name === "qty_c_class"
      
      ) {
        // Update master_qty or inner_qty
        updatedList[index][name] = inputValue;
      } else if (
        name === "master_transfer_qty" ||
        name === "delivery_qty_export" ||
        name === "delivery_qty_a_class" ||
        name === "delivery_qty_b_class" ||
        name === "delivery_qty_c_class" 
      ) {
        // Validation for master_transfer_qty and inner_transfer_qty
        const masterQty = updatedList[index].master_qty || 0;
        const exportQty = updatedList[index].qty_export || 0;
        const aClassQty = updatedList[index].qty_a_class || 0;
        const bClassQty = updatedList[index].qty_b_class || 0;
        const cClassQty = updatedList[index].qty_c_class || 0;

        if (name === "master_transfer_qty") {
          // Ensure master_transfer_qty doesn't exceed master_qty
          // if (inputValue > masterQty) {
          //   Swal.fire({
          //     icon: "error",
          //     title: "Validation Error",
          //     text: "Master transfer quantity cannot be greater than master quantity.",
          //     confirmButtonText: "OK",
          //   });
          //   updatedList[index].master_transfer_qty = 0; // Reset to 0 if invalid
          // } else {
          // Update master_transfer_qty
          updatedList[index].master_transfer_qty = inputValue;
          // }
        }

        if (name === "delivery_qty_export") {
          // Ensure inner_transfer_qty doesn't exceed inner_qty
          // if (inputValue > innerQty) {
          //   Swal.fire({
          //     icon: "error",
          //     title: "Validation Error",
          //     text: "Inner transfer quantity cannot be greater than inner quantity.",
          //     confirmButtonText: "OK",
          //   });
          //   updatedList[index].inner_transfer_qty = 0; // Reset to 0 if invalid
          // } else {
          // Update inner_transfer_qty
          updatedList[index].delivery_qty_export = inputValue;
          // }
        }
        if (name === "delivery_qty_a_class") {
          // Ensure inner_transfer_qty doesn't exceed inner_qty
          // if (inputValue > innerQty) {
          //   Swal.fire({
          //     icon: "error",
          //     title: "Validation Error",
          //     text: "Inner transfer quantity cannot be greater than inner quantity.",
          //     confirmButtonText: "OK",
          //   });
          //   updatedList[index].inner_transfer_qty = 0; // Reset to 0 if invalid
          // } else {
          // Update inner_transfer_qty
          updatedList[index].delivery_qty_a_class = inputValue;
          // }
        }
        if (name === "delivery_qty_b_class") {
          // Ensure inner_transfer_qty doesn't exceed inner_qty
          // if (inputValue > innerQty) {
          //   Swal.fire({
          //     icon: "error",
          //     title: "Validation Error",
          //     text: "Inner transfer quantity cannot be greater than inner quantity.",
          //     confirmButtonText: "OK",
          //   });
          //   updatedList[index].inner_transfer_qty = 0; // Reset to 0 if invalid
          // } else {
          // Update inner_transfer_qty
          updatedList[index].delivery_qty_b_class = inputValue;
          // }
        }
        if (name === "delivery_qty_c_class") {
          // Ensure inner_transfer_qty doesn't exceed inner_qty
          // if (inputValue > innerQty) {
          //   Swal.fire({
          //     icon: "error",
          //     title: "Validation Error",
          //     text: "Inner transfer quantity cannot be greater than inner quantity.",
          //     confirmButtonText: "OK",
          //   });
          //   updatedList[index].inner_transfer_qty = 0; // Reset to 0 if invalid
          // } else {
          // Update inner_transfer_qty
          updatedList[index].delivery_qty_c_class = inputValue;
          // }
        }
      }

      if (name === "qty_export") {
        setExportQty(inputValue);
      }
      if (name === "qty_a_class") {
        setAClassQty(inputValue);
      }
      if (name === "qty_b_class") {
        setBClassQty(inputValue);
      }
      if (name === "qty_c_class") {
        setCClassQty(inputValue);
      }
      if (name === "master_qty") {
        setMasterQty(inputValue);
      }

      // if (name === "inner_transfer_qty") {
      //   if (inputValue > innerQty) {
      //     Swal.fire({
      //       icon: "error",
      //       title: "Validation Error",
      //       text: "Transfer quantity is greater than production quantity.",
      //       confirmButtonText: "OK",
      //     });
      //     e.target.value = 0;
      //   }
      // }
      // if (name === "master_transfer_qty") {
      //   if (inputValue > masterQty) {
      //     Swal.fire({
      //       icon: "error",
      //       title: "Validation Error",
      //       text: "Transfer quantity is greater than production quantity.",
      //       confirmButtonText: "OK",
      //     });
      //     e.target.value = 0;
      //   }
      // }

      setList(updatedList); // Update the list state with the new values
      setDisplayErrorMessage((prev) => ({ ...prev, [name]: "" })); // Clear error message
    } else {
      // Show error if the input is not numeric
      setDisplayErrorMessage((prev) => ({
        ...prev,
        [name]: "Only numbers are allowed!",
      }));
    }
  };

  const handleNumberInputChangeForSet = (
    e,
    index,
    totalProduction = 0,
    totalTransfer = 0,
  ) => {
    const { name, value } = e.target;
    const inputValue = Number(value);

    let adjustedProduction = Number(totalProduction);

    // If field is production_qty, we want to add input value to totalProduction
    if (
      name === "production_qty" ||
      name === "qty_export" ||
      name === "qty_a_class" ||
      name === "qty_b_class" ||
      (name === "qty_c_class" && inputValue > 0)
    ) {
      setProduction(inputValue);
    }

    const availableQty =
      adjustedProduction + production - Number(totalTransfer);

    if (totalProduction > 0 && totalTransfer > 0) {
      if (inputValue > availableQty) {
        Swal.fire({
          icon: "error",
          title: "Invalid Transfer",
          text: "Transfer can't be more than " + availableQty,
          confirmButtonText: "OK",
        });
        e.target.value = 0;
      }
    }
    if (/^\d*$/.test(value)) {
      // const lists = Array.isArray(groupSetData)
      // ? groupSetData.flatMap(group => group.items)
      // : [];
      // const updatedList = [...lists];
      const updatedList = [...groupSetData];
      // const concat = updatedList.concat(lists);

      if (name === "transfer_qty") {
        const totalProductionQty = updatedList[index].total_production_qty || 0;
        const productionQty =
          parseFloat(updatedList[index].production_qty) || 0;
        const totalTransferQty = updatedList[index].total_transfer_qty || 0;

        const maxTransferQty =
          totalProductionQty + productionQty - totalTransferQty;
        setDisplayErrorMessage((prev) => ({ ...prev, [name]: "" })); // Clear error
      } else {
        setDisplayErrorMessage((prev) => ({ ...prev, [name]: "" })); // Clear error for numeric input
      }

      if (name === "qty_export") {
        // console.log("ABC", inputValue);

        setExportQty(inputValue);
      }
      if (name === "qty_a_class") {
        // console.log("ABC", inputValue);

        setAClassQty(inputValue);
      }
      if (name === "qty_b_class") {
        // console.log("ABC", inputValue);

        setBClassQty(inputValue);
      }
      if (name === "qty_c_class") {
        // console.log("ABC", inputValue);

        setCClassQty(inputValue);
      }
      if (name === "master_qty") {
        setMasterQty(inputValue);
      }

      // if (name === "inner_transfer_qty") {
      //   if (inputValue > innerQty) {
      //     Swal.fire({
      //       icon: "error",
      //       title: "Validation Error",
      //       text: "Transfer quantity is greater than production quantity.",
      //       confirmButtonText: "OK",
      //     });
      //     e.target.value = 0;
      //   }
      // }
      // if (name === "master_transfer_qty") {
      //   if (inputValue > masterQty) {
      //     Swal.fire({
      //       icon: "error",
      //       title: "Validation Error",
      //       text: "Transfer quantity is greater than production quantity.",
      //       confirmButtonText: "OK",
      //     });
      //     e.target.value = 0;
      //   }
      // }

      updatedList[index][name] = inputValue;
      setSets(updatedList);
    } else {
      setDisplayErrorMessage((prev) => ({
        ...prev,
        [name]: "Only numbers are allowed!",
      }));
    }
  };

  // console.log(list, "inputs");
  // console.log(sets, "inputs");

  // Add this function, for example, right after your imports or at the top of your component file.
  const isProductQtyFieldsEmpty = (productItem) => {
    if (!productItem) return true; // If no product item, consider fields as empty

    const fieldsToCheck = [
      "production_qty",
      "qty_export",
      "qty_a_class",
      "qty_b_class",
      "qty_c_class",
      // "inner_qty", // Applies to PStore items
      "master_qty", // Applies to PStore items
    ];

    // Returns true if ALL fields are empty or zero, false if ANY is filled.
    return !fieldsToCheck.some((field) => {
      const value = productItem[field];
      // Check if the value is defined, not null, not an empty string, and not numerically zero.
      // We use String(value).trim() !== '' to handle cases where value might be a string "0" or just ""
      // We use Number(value) !== 0 to ensure that actual numeric 0 also counts as empty.
      return (
        value !== undefined &&
        value !== null &&
        String(value).trim() !== "" &&
        Number(value) !== 0
      );
    });
  };

  return (
    <div>
      <IsLogin></IsLogin>
      {/* <LoaderComponent /> */}
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Production and Deliver</h5>
        </div>
        <div className="am-pagebody row d-flex justify-content-evenly">
          <div className="card pd-20 pd-sm-40 col-11">
            <h6 className="card-body-title mg-sm-b-30">
              Production and Delivery
            </h6>
            {/* <p>Transfer To Department {inputs.to_department}</p> */}
            <div className="row">
              <div className="col-lg">
                <label>Receipt No</label>
                <input
                  type="text"
                  className="form-control"
                  name="receipt_no"
                  value={inputs.receipt_no}
                  disabled
                />
              </div>
              <div className="col-lg">
                <label>Entry Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="entry_date"
                  value={inputs.entry_date}
                  onChange={handleChange}
                />
              </div>

              <div className="col-lg">
                <label>Shift</label>
                <select
                  className="form-control"
                  name="shift"
                  value={inputs.shift}
                  data-required
                  onChange={handleChange}
                >
                  <option value="">Select Shift</option>
                  <option value="a">A</option>
                  <option value="b">B</option>
                  <option value="c">C</option>
                  <option value="general">General</option>
                </select>
              </div>

              <div className="col-lg">
                <label>Remarks</label>
                <textarea
                  className="form-control"
                  name="remarks"
                  value={inputs.remarks}
                />
              </div>
            </div>

            {/* Item List */}
            <div className="row mt-3">
              <div className="card-solid">
                <div className="card-header with-border text-center">
                  <h5 className="card-title mb-0">Items in the Production</h5>
                </div>
              </div>
              <div className="col-lg">
                <table className="table table-sm">
                  <thead>
                    <tr>
                      <th rowSpan="2" colSpan={2}>Product Name</th>
                      <th rowSpan="2">Shape</th>
                      
                      {/* Conditionally render columns based on department */}
                      {receiveData.from_department_art_id === 13 && (
                        <th colSpan="4" className="text-center">Export Qty</th>
                      )}
                      
                      {receiveData.from_department_art_id === 12 && (
                        <>
                          <th colSpan="4" className="text-center">A Class</th>
                          <th colSpan="4" className="text-center">B Class</th>
                          {/* <th colSpan="4" className="text-center">C Class</th> */}
                        </>
                      )}
                      
                      {/* Master Qty Column Group - always show */}
                      <th colSpan="4" className="text-center">Master Qty</th>
                    </tr>
                    <tr>
                      {/* Export Qty Sub-columns - only for department 13 */}
                      {receiveData.from_department_art_id === 13 && (
                        <>
                          <th colSpan={2} className="text-center">Production</th>
                      {/* <th className="text-center">Production</th> */}
                      <th colSpan={2} className="text-center">Delivery</th>
                      {/* <th className="text-center">Transfer</th> */}
                        </>
                      )}
                      
                      {/* A, B, C Class Sub-columns - only for department 12 */}
                      {receiveData.from_department_art_id === 12 && (
                        <>
                          {/* A Class Sub-columns */}
                          <th colSpan={2} className="text-center">Production</th>
                      {/* <th className="text-center">Production</th> */}
                      <th colSpan={2} className="text-center">Delivery</th>
                      {/* <th className="text-center">Transfer</th> */}
                          
                          {/* B Class Sub-columns */}
                          <th colSpan={2} className="text-center">Production</th>
                      {/* <th className="text-center">Production</th> */}
                      <th colSpan={2} className="text-center">Delivery</th>
                      {/* <th className="text-center">Transfer</th> */}
                          
                          {/* C Class Sub-columns */}
                          {/* <th className="text-center">Total Production</th>
                          <th className="text-center">Production</th>
                          <th className="text-center">Total Transfer</th>
                          <th className="text-center">Transfer</th> */}
                        </>
                      )}
                      
                      {/* Master Qty Sub-columns - always show */}
                      <th colSpan={2} className="text-center">Production</th>
                      {/* <th className="text-center">Production</th> */}
                      <th colSpan={2} className="text-center">Delivery</th>
                      {/* <th className="text-center">Transfer</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {list.map((item, productIndex) => {
                      const itemKey =
                        item.id || item.planning_item_id || productIndex;
                      const recipeRows =
                        recipeRowsByItem[itemKey] || getInitialRecipeRows();
                      const recipeErrorMessage =
                        recipeErrorMessages[itemKey] || "";

                      return (
                        <React.Fragment key={productIndex}>
                          <tr>
                            <td colSpan={2}>
                              {item.product?.code} ||
                              {item.product?.name}
                              {/* <br />
                              Shape: {item.shape?.name} <br />
                              Glaze: {item?.glaze?.colour_name} <br />
                              Decoration: {item?.decoration?.code} (
                              {item?.decoration_name}) */}
                            </td>
                            <td>{item.shape?.name}</td>

                            {role === "pstore" && (
                              <>
                                {/* Export Qty Columns - Only for department 13 */}
                                {receiveData.from_department_art_id === 13 && (
                                  <>
                                    <td>
                                      Total production: {(totalProductionAndTotalTransfer &&
                                        totalProductionAndTotalTransfer[
                                          item?.planning_item_id
                                        ]?.total_production_qty_export) ||
                                        0} <br />
                                        Stock: {item?.current_stock_export_qty || 0} <br />
                                        Required: {item.required_qty_export} <br />
                                    </td>
                                    <td>
                                      <div className="input-group mb-3">
                                        <input
                                          type="text"
                                          className="form-control"
                                          onInput={(e) =>
                                            (e.target.value =
                                              e.target.value.replace(/\D/g, ""))
                                          }
                                          name="qty_export"
                                          placeholder="Export Qty"
                                          onChange={(e) =>
                                            handleNumberInputChange(e, productIndex)
                                          }
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      Total Delivery: {(totalProductionAndTotalTransfer &&
                                        totalProductionAndTotalTransfer[
                                          item?.planning_item_id
                                        ]?.total_delivery_export_qty) ||
                                        0} <br />
                                        Remaining: {item.required_qty_export -
                                        ((totalProductionAndTotalTransfer &&
                                          totalProductionAndTotalTransfer[
                                            item?.planning_item_id
                                          ]?.total_delivery_export_qty) ||
                                          0)}
                                    </td>
                                    <td>
                                      <div className="input-group mb-3">
                                        <input
                                          type="text"
                                          className="form-control"
                                          onInput={(e) =>
                                            (e.target.value =
                                              e.target.value.replace(/\D/g, ""))
                                          }
                                          name="delivery_qty_export"
                                          placeholder="Export Transfer Qty"
                                          onChange={(e) =>
                                            handleNumberInputChangeForTransfer(
                                              e,
                                              productIndex,
                                            )
                                          }
                                        />
                                      </div>
                                    </td>
                                  </>
                                )}
                                {/* <td>
                                  {item.required_qty_export -
                                    ((totalProductionAndTotalTransfer &&
                                      totalProductionAndTotalTransfer[
                                        item?.planning_item_id
                                      ]?.total_delivery_export_qty) ||
                                      0)}
                                </td> */}
                                {/* export  */}

                                {/* A, B, C Class Columns - Only for department 12 */}
                                {receiveData.from_department_art_id === 12 && (
                                  <>
                                    {/* A class  */}
                                    <td>
                                      Total production: {(totalProductionAndTotalTransfer &&
                                        totalProductionAndTotalTransfer[
                                          item?.planning_item_id
                                        ]?.total_production_qty_a) ||
                                        0} <br />
                                      Stock: {item?.current_stock_qty_a || 0} <br />
                                      Required: {item.required_qty_a} <br />
                                    </td>
                                {/* <td>
                                  {item?.current_stock_qty_a || 0}
                                  
                                </td>
                                <td>{item.required_qty_a}</td> */}
                                <td>
                                  <div className="input-group mb-3">
                                    <input
                                      type="text"
                                      className="form-control"
                                      onInput={(e) =>
                                        (e.target.value =
                                          e.target.value.replace(/\D/g, ""))
                                      }
                                      name="qty_a_class"
                                      placeholder="A Qty"
                                      // defaultValue={list[productIndex]?.qty_export || ""}
                                      onChange={(e) =>
                                        handleNumberInputChange(e, productIndex)
                                      }
                                    />
                                  </div>
                                </td>
                                <td>
                                  Total Delivery: {(totalProductionAndTotalTransfer &&
                                    totalProductionAndTotalTransfer[
                                      item?.planning_item_id
                                    ]?.total_delivery_a_class) ||
                                    0} <br />
                                  Remaining: {item.required_qty_a -
                                  ((totalProductionAndTotalTransfer &&
                                    totalProductionAndTotalTransfer[
                                      item?.planning_item_id
                                    ]?.total_delivery_a_class) ||
                                    0)}
                                </td>
                                <td>
                                  <div className="input-group mb-3">
                                    <input
                                      type="text"
                                      className="form-control"
                                      onInput={(e) =>
                                        (e.target.value =
                                          e.target.value.replace(/\D/g, ""))
                                      }
                                      name="delivery_qty_a_class"
                                      placeholder="A Transfer Qty"
                                      // defaultValue={list[productIndex]?.qty_export || ""}
                                      onChange={(e) =>
                                        handleNumberInputChangeForTransfer(
                                          e,
                                          productIndex,
                                        )
                                      }
                                    />
                                  </div>
                                </td>
                                {/* <td>
                                  {item.required_qty_a -
                                    ((totalProductionAndTotalTransfer &&
                                      totalProductionAndTotalTransfer[
                                        item?.planning_item_id
                                      ]?.total_delivery_a_class) ||
                                      0)}
                                </td> */}
                                {/* A class  */}

                                {/* B Class  */}
                                <td>
                                  Total production: {(totalProductionAndTotalTransfer &&
                                    totalProductionAndTotalTransfer[
                                      item?.planning_item_id
                                    ]?.total_production_qty_b) ||
                                    0} <br />
                                  Stock: {item?.current_stock_qty_b || 0} <br />
                                  Required: {item.required_qty_b} <br />
                                </td>
                                {/* <td>
                                  {item?.current_stock_qty_b || 0}
                                  
                                </td>
                                <td>{item.required_qty_b}</td> */}
                                <td>
                                  <div className="input-group mb-3">
                                    <input
                                      type="text"
                                      className="form-control"
                                      onInput={(e) =>
                                        (e.target.value =
                                          e.target.value.replace(/\D/g, ""))
                                      }
                                      name="qty_b_class"
                                      placeholder="B Qty"
                                      // defaultValue={list[productIndex]?.qty_export || ""}
                                      onChange={(e) =>
                                        handleNumberInputChange(e, productIndex)
                                      }
                                    />
                                  </div>
                                </td>
                                <td>
                                  Total Delivery: {(totalProductionAndTotalTransfer &&
                                    totalProductionAndTotalTransfer[
                                      item?.planning_item_id
                                    ]?.total_delivery_b_class) ||
                                    0} <br />
                                    Remaining: {item.required_qty_b -
                                    ((totalProductionAndTotalTransfer &&
                                      totalProductionAndTotalTransfer[
                                        item?.planning_item_id
                                      ]?.total_delivery_b_class) ||
                                      0)}
                                </td>
                                <td>
                                  <div className="input-group mb-3">
                                    <input
                                      type="text"
                                      className="form-control"
                                      onInput={(e) =>
                                        (e.target.value =
                                          e.target.value.replace(/\D/g, ""))
                                      }
                                      name="delivery_qty_b_class"
                                      placeholder="B Transfer Qty"
                                      // defaultValue={list[productIndex]?.qty_export || ""}
                                      onChange={(e) =>
                                        handleNumberInputChangeForTransfer(
                                          e,
                                          productIndex,
                                        )
                                      }
                                    />
                                  </div>
                                </td>
                                {/* <td>
                                  {item.required_qty_b -
                                    ((totalProductionAndTotalTransfer &&
                                      totalProductionAndTotalTransfer[
                                        item?.planning_item_id
                                      ]?.total_delivery_b_class) ||
                                      0)}
                                </td> */}
                                {/* B Class  */}

                                {/* C Class  */}
                                {/* <td>
                                   Total production: {(totalProductionAndTotalTransfer &&
                                    totalProductionAndTotalTransfer[
                                      item?.planning_item_id
                                    ]?.total_production_qty_c) ||
                                    0} <br />
                                    Stock: {item?.current_stock_qty_c || 0}
                                    Required: {item.required_qty_c} <br />
                                </td>
                                
                                <td>
                                  <div className="input-group mb-3">
                                    <input
                                      type="text"
                                      className="form-control"
                                      onInput={(e) =>
                                        (e.target.value =
                                          e.target.value.replace(/\D/g, ""))
                                      }
                                      name="qty_c_class"
                                      placeholder="C Qty"
                                      // defaultValue={list[productIndex]?.qty_export || ""}
                                      onChange={(e) =>
                                        handleNumberInputChange(e, productIndex)
                                      }
                                    />
                                  </div>
                                </td>
                                <td>
                                   Total delivery: {(totalProductionAndTotalTransfer &&
                                    totalProductionAndTotalTransfer[
                                      item?.planning_item_id
                                    ]?.total_delivery_c_class) ||
                                    0} <br />
                                    Remaining: {item.required_qty_c -
                                    ((totalProductionAndTotalTransfer &&
                                      totalProductionAndTotalTransfer[
                                        item?.planning_item_id
                                      ]?.total_delivery_c_class) ||
                                      0)}
                                </td>
                                <td>
                                  <div className="input-group mb-3">
                                    <input
                                      type="text"
                                      className="form-control"
                                      onInput={(e) =>
                                        (e.target.value =
                                          e.target.value.replace(/\D/g, ""))
                                      }
                                      name="delivery_qty_c_class"
                                      placeholder="C Transfer Qty"
                                      // defaultValue={list[productIndex]?.qty_export || ""}
                                      onChange={(e) =>
                                        handleNumberInputChangeForTransfer(
                                          e,
                                          productIndex,
                                        )
                                      }
                                    />
                                  </div>
                                </td> */}
                                

                                {/* C Class  */}
                                  </>
                                )}




                                {/* Master Qty  */}
                                <td>
                                  Total production: {(totalProductionAndTotalTransfer &&
                                    totalProductionAndTotalTransfer[
                                      item?.planning_item_id
                                    ]?.total_production_master_qty) ||
                                    0} <br />
                                    Stock: {item?.current_stock_master_qty || 0} <br />
                                    Required: {item.required_master_qty}
                                </td>
                                {/* <td>
                                  {item?.current_stock_master_qty || 0}



                                  {(totalProductionAndTotalTransfer &&
                                    totalProductionAndTotalTransfer[
                                      item?.planning_item_id
                                    ]?.total_production_master_qty -
                                      totalProductionAndTotalTransfer[
                                        item?.planning_item_id
                                      ]?.total_delivery_master_qty) ||
                                    0}
                                </td>
                                <td>{item.required_master_qty}</td> */}
                                <td>
                                  <div className="input-group mb-3">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Master Qty"
                                      onInput={(e) =>
                                        (e.target.value =
                                          e.target.value.replace(/\D/g, ""))
                                      }
                                      name="master_qty"
                                      // defaultValue={list[productIndex]?.qty_export || ""}
                                      onChange={(e) =>
                                        handleNumberInputChange(e, productIndex)
                                      }
                                    />
                                  </div>
                                </td>
                                <td>
                                  Total Delivery: {(totalProductionAndTotalTransfer &&
                                    totalProductionAndTotalTransfer[
                                      item?.planning_item_id
                                    ]?.total_delivery_master_qty) ||
                                    0} <br />
                                    Remaining: {item.required_master_qty -
                                    ((totalProductionAndTotalTransfer &&
                                      totalProductionAndTotalTransfer[
                                        item?.planning_item_id
                                      ]?.total_delivery_master_qty) ||
                                      0)}
                                </td>
                                <td>
                                  <div className="input-group mb-3">
                                    <input
                                      type="text"
                                      placeholder="Master Transfer Qty"
                                      className="form-control"
                                      onInput={(e) =>
                                        (e.target.value =
                                          e.target.value.replace(/\D/g, ""))
                                      }
                                      name="master_transfer_qty"
                                      // defaultValue={list[productIndex]?.qty_export || ""}
                                      onChange={(e) =>
                                        handleNumberInputChangeForTransfer(
                                          e,
                                          productIndex,
                                        )
                                      }
                                    />
                                  </div>
                                </td>
                                {/* <td>
                                  {item.required_master_qty -
                                    ((totalProductionAndTotalTransfer &&
                                      totalProductionAndTotalTransfer[
                                        item?.planning_item_id
                                      ]?.total_delivery_master_qty) ||
                                      0)}
                                </td> */}
                                {/* Master Qty  */}
                              </>
                              //   )}
                              // </>
                            )}
                          </tr>
                          {role === "pstore" && (
                            <tr>
                              <td colSpan={17}>
                                <div className="row mt-2">
                                  <div className="col-10"></div>
                                  <div className="col-2">
                                    <button
                                      className="btn btn-info btn-block mg-b-10"
                                      type="button"
                                      onClick={() => addMoreRecipeRow(itemKey)}
                                    >
                                      <i className="fa fa-plus mg-r-10"></i> ADD
                                      More
                                    </button>
                                  </div>
                                  <div className="col-12">
                                    <table className="table table-sm align-items-center mb-0">
                                      <thead>
                                        <tr>
                                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                            Product
                                          </th>
                                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                            Qty
                                          </th>
                                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                            Description
                                          </th>
                                          {recipeRows.length > 1 && (
                                            <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                              Action
                                            </th>
                                          )}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {recipeRows.map((x, i) => (
                                          <tr key={i}>
                                            <td className="d-flex">
                                              <Select
                                                options={recipeOptions}
                                                name="rmpm_id"
                                                className="form-control"
                                                onChange={(
                                                  selectedOption,
                                                  actionMeta,
                                                ) =>
                                                  handleRecipeSelectChange(
                                                    selectedOption,
                                                    actionMeta,
                                                    itemKey,
                                                    i,
                                                  )
                                                }
                                                placeholder="Select Product"
                                                value={
                                                  recipeOptions.find(
                                                    (opt) =>
                                                      opt.value === x.rmpm_id,
                                                  ) || null
                                                }
                                              />
                                            </td>
                                            <td className="">
                                              <div className="input-group mb-3">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  name="qty"
                                                  value={x.qty || ""}
                                                  onChange={(e) =>
                                                    handleRecipeNumberInputChange(
                                                      e,
                                                      itemKey,
                                                      i,
                                                    )
                                                  }
                                                  readOnly={isProductQtyFieldsEmpty(
                                                    list[productIndex],
                                                  )}
                                                  // data-required
                                                  onInput={(e) =>
                                                    (e.target.value =
                                                      e.target.value.replace(
                                                        /\D/g,
                                                        "",
                                                      ))
                                                  }
                                                />
                                                <span className="input-group-text">
                                                  {recipeOptions.find(
                                                    (opt) =>
                                                      opt.value === x.rmpm_id,
                                                  )?.unitName || ""}
                                                </span>
                                              </div>
                                              {recipeErrorMessage && (
                                                <div className="text-danger small">
                                                  {recipeErrorMessage}
                                                </div>
                                              )}
                                            </td>

                                            <td>
                                              <textarea
                                                className="form-control"
                                                name="desc"
                                                value={x.desc || ""}
                                                onChange={(e) =>
                                                  handleRecipeRowChange(
                                                    e,
                                                    itemKey,
                                                    i,
                                                  )
                                                }
                                              ></textarea>
                                            </td>
                                            {recipeRows.length > 1 && (
                                              <td>
                                                <button
                                                  className="btn btn-danger btn-block"
                                                  type="button"
                                                  onClick={() =>
                                                    removeRecipeRow(itemKey, i)
                                                  }
                                                >
                                                  <i className="fa fa-trash"></i>
                                                </button>
                                              </td>
                                            )}
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                    {role === "pstore" && (
                      <>
                        <tr>
                          {/* {(role === "pstore") && (
                            <> */}
                          {/* {(DeparmenType === "packing_export" || DeparmenType === "packing_local") && (<> */}
                          {/* {groupSetData && (
                            <th className="" colSpan={2}>
                              Set Name
                            </th>
                          )}  */}
                          {/* <th className="text-center">Total Production Inner Qty</th>
                          <th className="text-center">Required Inner Qty</th>
                          <th className="text-center">Inner Transfer Qty</th>
                          <th className="text-center">Required Master Qty</th>
                          <th className="text-center">Total Production Master Qty</th>
                          <th className="text-center">Master Transfer Qty</th> */}
                          {/* </>)} */}
                          {/* </>
                          )} */}
                        </tr>

                        {groupSetData?.map((i, productIndex) => {
                          return (
                            <>
                              <tr key={productIndex}>
                                <td colSpan={3}>
                                  <strong>Set Name: {i.set_name}</strong>

                                  <br />
                                  <div className="py-2">
                                    <ul style={{ listStyle: "none" }}>
                                      {i?.items.map((item) => {
                                        return (
                                          <>
                                            <li>* {item.product.name}</li>
                                          </>
                                        );
                                      })}
                                    </ul>
                                  </div>
                                </td>
                                {role === "pstore" && (
                                  <>
                                    {/* {(DeparmenType === "packing_export") && ( */}
                                    <>
                                    {/* Export Qty Columns - Only for department 13 */}
                                    {receiveData.from_department_art_id === 13 && (
                                      <>
                                      {/* Export  */}
                                        <td>{i?.total_production_qty_export}</td>
                                        <td>
                                          {i?.total_production_qty_export -
                                            i?.total_delivery_export_qty}
                                        </td>
                                        <td>{i?.required_qty_export}</td>
                                        <td>
                                          <div className="input-group mb-3">
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Export qty"
                                              onInput={(e) =>
                                                (e.target.value =
                                                  e.target.value.replace(
                                                    /\D/g,
                                                    "",
                                                  ))
                                              }
                                              name="qty_export"
                                              // defaultValue={list[productIndex]?.qty_export || ""}
                                              onChange={(e) =>
                                                handleNumberInputChangeForSet(
                                                  e,
                                                  productIndex,
                                                )
                                              }
                                            />
                                          </div>
                                        </td>
                                        <td>{i?.total_delivery_export_qty}</td>
                                        <td>
                                          <div className="input-group mb-3">
                                            <input
                                              type="text"
                                              className="form-control"
                                              onInput={(e) =>
                                                (e.target.value =
                                                  e.target.value.replace(
                                                    /\D/g,
                                                    "",
                                                  ))
                                              }
                                              placeholder="Export transfer qty"
                                              name="delivery_qty_export"
                                              // defaultValue={list[productIndex]?.qty_export || ""}
                                              onChange={(e) =>
                                                handleNumberInputChangeForSet(
                                                  e,
                                                  productIndex,
                                                )
                                              }
                                            />
                                          </div>
                                        </td>
                                        <td>
                                          {i.required_qty_export -
                                            ((totalProductionAndTotalTransfer &&
                                              totalProductionAndTotalTransfer[
                                                i?.planning_item_id
                                              ]?.total_delivery_export_qty) ||
                                              0)}
                                        </td>
                                        {/* Export  */}
                                      </>
                                    )}

                                    {/* A Class  */}
                                    {receiveData.from_department_art_id === 12 && (
                                      <>
                                      <td>{i?.total_production_qty_a}</td>
                                      <td>
                                        {i?.total_production_qty_a -
                                          i?.total_delivery_a_class}
                                      </td>
                                      <td>{i?.required_qty_a}</td>
                                      <td>
                                        <div className="input-group mb-3">
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="A qty"
                                            onInput={(e) =>
                                              (e.target.value =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  "",
                                                ))
                                            }
                                            name="qty_a_class"
                                            // defaultValue={list[productIndex]?.qty_export || ""}
                                            onChange={(e) =>
                                              handleNumberInputChangeForSet(
                                                e,
                                                productIndex,
                                              )
                                            }
                                          />
                                        </div>
                                      </td>
                                      <td>{i?.total_delivery_a_class}</td>
                                      <td>
                                        <div className="input-group mb-3">
                                          <input
                                            type="text"
                                            className="form-control"
                                            onInput={(e) =>
                                              (e.target.value =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  "",
                                                ))
                                            }
                                            placeholder="A transfer qty"
                                            name="delivery_qty_a_class"
                                            // defaultValue={list[productIndex]?.qty_export || ""}
                                            onChange={(e) =>
                                              handleNumberInputChangeForSet(
                                                e,
                                                productIndex,
                                              )
                                            }
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        {i.required_qty_a -
                                          ((totalProductionAndTotalTransfer &&
                                            totalProductionAndTotalTransfer[
                                              i?.planning_item_id
                                            ]?.total_delivery_a_class) ||
                                            0)}
                                      </td>
                                      {/* A Class  */}
                                      </>
                                    )}

                                    {/* B Class  */}
                                    {receiveData.from_department_art_id === 12 && (
                                      <>
                                      <td>{i?.total_production_qty_b}</td>
                                      <td>
                                        {i?.total_production_qty_b -
                                          i?.total_delivery_b_class}
                                      </td>
                                      <td>{i?.required_qty_b}</td>
                                      <td>
                                        <div className="input-group mb-3">
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="B qty"
                                            onInput={(e) =>
                                              (e.target.value =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  "",
                                                ))
                                            }
                                            name="qty_b_class"
                                            // defaultValue={list[productIndex]?.qty_export || ""}
                                            onChange={(e) =>
                                              handleNumberInputChangeForSet(
                                                e,
                                                productIndex,
                                              )
                                            }
                                          />
                                        </div>
                                      </td>
                                      <td>{i?.total_delivery_b_class}</td>
                                      <td>
                                        <div className="input-group mb-3">
                                          <input
                                            type="text"
                                            className="form-control"
                                            onInput={(e) =>
                                              (e.target.value =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  "",
                                                ))
                                            }
                                            placeholder="B transfer qty"
                                            name="delivery_qty_b_class"
                                            // defaultValue={list[productIndex]?.qty_export || ""}
                                            onChange={(e) =>
                                              handleNumberInputChangeForSet(
                                                e,
                                                productIndex,
                                              )
                                            }
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        {i.required_qty_b -
                                          ((totalProductionAndTotalTransfer &&
                                            totalProductionAndTotalTransfer[
                                              i?.planning_item_id
                                            ]?.total_delivery_b_class) ||
                                            0)}
                                      </td>
                                      {/* B Class  */}
                                      </>
                                    )}

                                    {/* C Class  */}
                                    {receiveData.from_department_art_id === 12 && (
                                      <>
                                      <td>{i?.total_production_qty_c}</td>
                                      <td>
                                        {i?.total_production_qty_c -
                                          i?.total_delivery_c_class}
                                      </td>
                                      <td>{i?.required_qty_c}</td>
                                      <td>
                                        <div className="input-group mb-3">
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="C qty"
                                            onInput={(e) =>
                                              (e.target.value =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  "",
                                                ))
                                            }
                                            name="qty_c_class"
                                            // defaultValue={list[productIndex]?.qty_export || ""}
                                            onChange={(e) =>
                                              handleNumberInputChangeForSet(
                                                e,
                                                productIndex,
                                              )
                                            }
                                          />
                                        </div>
                                      </td>
                                      <td>{i?.total_delivery_c_class}</td>
                                      <td>
                                        <div className="input-group mb-3">
                                          <input
                                            type="text"
                                            className="form-control"
                                            onInput={(e) =>
                                              (e.target.value =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  "",
                                                ))
                                            }
                                            placeholder="C transfer qty"
                                            name="delivery_qty_c_class"
                                            // defaultValue={list[productIndex]?.qty_export || ""}
                                            onChange={(e) =>
                                              handleNumberInputChangeForSet(
                                                e,
                                                productIndex,
                                              )
                                            }
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        {i.required_qty_c -
                                          ((totalProductionAndTotalTransfer &&
                                            totalProductionAndTotalTransfer[
                                              i?.planning_item_id
                                            ]?.total_delivery_c_class) ||
                                            0)}
                                      </td>
                                      {/* C Class  */}
                                      </>
                                    )}



                                      <td>{i?.total_master_qty}</td>
                                      <td>
                                        {i?.total_master_qty -
                                          i?.total_delivery_master_qty}
                                      </td>
                                      <td>{i?.required_master_qty}</td>
                                      <td>
                                        <div className="input-group mb-3">
                                          <input
                                            type="text"
                                            className="form-control"
                                            onInput={(e) =>
                                              (e.target.value =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  "",
                                                ))
                                            }
                                            placeholder="Master qty"
                                            name="master_qty"
                                            // defaultValue={list[productIndex]?.qty_export || ""}
                                            onChange={(e) =>
                                              handleNumberInputChangeForSet(
                                                e,
                                                productIndex,
                                              )
                                            }
                                          />
                                        </div>
                                      </td>
                                      <td>{i?.total_delivery_master_qty}</td>
                                      <td>
                                        <div className="input-group mb-3">
                                          <input
                                            type="text"
                                            className="form-control"
                                            onInput={(e) =>
                                              (e.target.value =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  "",
                                                ))
                                            }
                                            name="master_transfer_qty"
                                            placeholder="Master Transfer Qty"
                                            // defaultValue={list[productIndex]?.qty_export || ""}
                                            onChange={(e) =>
                                              handleNumberInputChangeForSet(
                                                e,
                                                productIndex,
                                              )
                                            }
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        {i.required_master_qty -
                                          ((totalProductionAndTotalTransfer &&
                                            totalProductionAndTotalTransfer[
                                              i?.planning_item_id
                                            ]?.total_delivery_master_qty) ||
                                            0)}
                                      </td>
                                    </>
                                    {/* )} */}
                                  </>
                                )}
                              </tr>
                            </>
                          );
                        })}
                      </>
                    )}
                  </tbody>
                </table>
                {/* <div className="card-header with-border text-center">
                  <h5 className="card-title mb-0">Items in the List</h5>
                </div>
                <table className="table table-sm table-bordered table-striped mb-0">
                  <thead>
                    <tr>
                      <th>Code</th>
                      <th>Product</th>
                      <th>Standard Qty</th>
                      <th>Stock Qty</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.length > 0 ? (
                      data.map((item, index) => (
                        <tr key={index}>
                          <td>{item.code}</td>
                          <td> <div className="input-group mb-3">{item.name}</div> </td>
                          <td>
                            <div className="input-group mb-3">
                              <input type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')} className="form-control" name="recipe_qty" onChange={(e) => handleRecepieChange(e, item.stockQty)} />
                              <span className="input-group-text">{item?.unit?.name}</span>
                            </div>
                          </td>
                          <td>{item.stockQty}</td>
                          <td></td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={4} className="text-center">
                          {receipeNotFound}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table> */}
              </div>
            </div>
            {/* <div className="row mt-3">
              <div className="card-solid">
                <div className="card-header with-border text-center">
                  <h5 className="card-title mb-0">Items in the List</h5>
                </div>
                <div className="card-body mt-3 p-0 pt-3">
                  <table className="table table-sm table-bordered table-striped mb-0">
                    <thead>
                      <tr>
                        <th>Code</th>
                        <th>Product</th>
                        <th>Standard Qty</th>
                        <th>Stock Qty</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list.length > 0 ? (
                        list.map((item, index) => (
                          <tr key={index}>
                            <td>{item.code}</td>
                            <td>{item.name}</td>
                            <td><div className="input-group mb-3">{item.stndrd_qty}</div> </td>
                            <td>{item?.stockQty}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={4} className="text-center">
                            {receipeNotFound}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div> */}

            <div className="row mt-3">
              <div className="col-3">
                <button className="btn btn-primary" onClick={formSubmit}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Create;
